import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { FileText, ArrowRight } from 'lucide-react';
import { Badge } from './ui/badge';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function RelatedDocs({ docId, currentTitle }) {
    const [relatedDocs, setRelatedDocs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (docId) {
            fetchRelatedDocs();
        }
    }, [docId]);

    const fetchRelatedDocs = async () => {
        try {
            const response = await axios.get(`${API}/docs/${docId}/related?limit=4`);
            setRelatedDocs(response.data);
        } catch (error) {
            console.error('Error fetching related docs:', error);
            setRelatedDocs([]);
        } finally {
            setLoading(false);
        }
    };

    if (loading || relatedDocs.length === 0) {
        return null;
    }

    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="mt-12 pt-8 border-t border-border"
        >
            <h3 className="text-xl font-mono font-bold mb-6">Ähnliche Dokumentationen</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {relatedDocs.map((doc, index) => (
                    <motion.div
                        key={doc.id}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.1 }}
                    >
                        <Link
                            to={`/docs/${doc.project_slug}/${doc.slug}`}
                            className="group block p-4 rounded-lg border border-border bg-card/50 hover:border-primary/50 hover:bg-card transition-all"
                        >
                            <div className="flex items-start gap-3">
                                <FileText className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                                <div className="flex-1 min-w-0">
                                    <h4 className="font-mono font-medium text-sm group-hover:text-primary transition-colors truncate">
                                        {doc.title}
                                    </h4>
                                    <div className="flex items-center gap-2 mt-1">
                                        <Badge variant="outline" className="text-xs">
                                            {doc.category}
                                        </Badge>
                                        {doc.project_name && (
                                            <span className="text-xs text-muted-foreground truncate">
                                                {doc.project_name}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <ArrowRight className="w-4 h-4 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all flex-shrink-0" />
                            </div>
                        </Link>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
}

export default RelatedDocs;
